import React, { Component } from 'react';
import { View, Text, StyleSheet, Image, Dimensions, TextInput, ScrollView, TouchableOpacity, ActivityIndicator } from 'react-native'
import Ionicon from 'react-ionicons'
import './Admin.css'
import { Modal, LoadingState, EmptyState } from '../components/Common';
import FakeData from '../fake-data';
import Support from './Support';

const { height, width } = Dimensions.get("window");

export default class Admin extends Component {
    constructor(props) {
        super(props)
        this.state = {
            active: "Blocked",
            isLogged: true,
            menus: [
                { text: "Inbox", notices: [] },
                { text: "Blocked", notices: [] },
            ]
        }
    }

    render() {
        const { menus, active, loginError, loginFields, isLogged } = this.state;
        const { } = this.props;
        if (!isLogged) {
            return (
                <AdminLoginForm onLogin={() => {
                    this.setState({ isLogged: true });
                }} />
            )
        }
        return (
            <View className="dashboard-window">
                <div className="dashboard-window-header">
                    <div className="dashboard-window-header-logo">
                        <img src={FakeData.you().image} />
                    </div>
                    <div className="dashboard-window-header-menu"></div>
                    <div className="dashboard-window-header-menu-list"></div>
                    <div className="dashboard-window-header-banner">
                        {
                            ["Admin Panel"].map((item, i) => {
                                return (
                                    <div className={""} key={i} onClick={() => {

                                    }}>
                                        {item}
                                    </div>
                                );
                            })
                        }
                    </div>
                    <div className="dashboard-window-header-nav">
                        {
                            menus.map((item, i) => {
                                return (
                                    <div key={i} onClick={() => {
                                        this.setState({ active: item.text });
                                        //this.refs['lblDrop'].blur()
                                    }} className={active === item.text ? "active" : ""}>{item.text}</div>
                                )
                            })
                        }
                    </div>
                </div>
                {active === "Inbox" &&
                    <div className="dashboard-window-content">
                        <Support isAdmin={true} />
                    </div>
                }
                {active === 'Blocked' &&
                    <Blocked />
                }
            </View>
        )
    }
}

class AdminLoginForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loginFields: {
                key: '',
                token: ''
            },
            isLoading: true,
            isSending: false,
            loginError: {
                key: false,
                token: false
            },
            log: {
                error: false,
                message: 'Please wait...'
            }
        }
    }

    componentDidMount() {
        this._isMounted = true;
        this.io = false;
        FakeData.$("#root").css({
            "overflow": "hidden"
        });
        this.getIO();
    }

    getIO = () => {
        const _that = this;
        const { loginError, loginFields, isSending, log, isLoading } = this.state;
        const { onLogin } = this.props;
        try {
            this.io = new window.io.connect(FakeData.apiURL+"/admin-login", { transports: ['websocket'] });;



            this.io.on("io_connect", (data) => {
                _that.setState({ log: data, isLoading: false });
            })

            this.io.on("log", (data) => {
                if (data.error) {
                    loginError.key = true
                    loginError.token = true
                    loginFields.token = '';
                    loginFields.key = '';
                    _that.setState({ log: data, isSending: false, loginError, loginFields });
                } else {
                    _that.setState({ log: data, isSending: false });
                    if (onLogin) {
                        onLogin()
                    }
                }
            })

        } catch (error) {
            this.io = false;
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
        FakeData.$("#root").css({
            "overflow": "auto"
        });
        this.io = false;
    }

    render() {
        const { loginError, loginFields, isSending, log, isLoading } = this.state;
        const { onLogin } = this.props;
        if (isLoading) {
            return (
                <View style={{
                    width: "60vh",
                    height: "60vh",
                    backgroundColor: "#fff",
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                    <LogMessage {...log} />
                    <ActivityIndicator coloe="#4ac" />
                </View>
            )
        }
        return (
            <View style={{
                width: "60vh",
                height: "60vh",
                backgroundColor: "#fff",
                justifyContent: 'center',
                alignItems: 'center',
            }}>
                <LogMessage {...log} />
                <View className={loginError.token ? "error" : ""} style={{
                    height: 40,
                    width: "40vh",
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderColor: "#345",
                    borderWidth: 1,
                    marginBottom: 10
                }}>
                    <input disabled={loginFields.token.length >= 10} value={loginFields.token} style={{
                        border: 'none',
                        width: '100%',
                        height: '100%'
                    }} onChange={(e) => {
                        const { value } = e.target;
                        loginFields.token = value;
                        loginError.token = value.length < 10 ? true : false
                        this.setState({ loginFields, loginError });
                    }} placeholder={"Secret Token"} />
                </View>
                <View className={loginError.key ? "error" : ""} style={{
                    height: 40,
                    width: "40vh",
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderColor: "#345",
                    borderWidth: 1,
                    marginBottom: 10
                }}>
                    <input disabled={loginFields.key.length >= 8} value={loginFields.key} style={{
                        border: 'none',
                        width: '100%',
                        height: '100%'
                    }} onChange={(e) => {
                        const { value } = e.target;
                        loginFields.key = value;
                        loginError.key = value.length < 8 ? true : false
                        this.setState({ loginFields, loginError });
                    }} placeholder={"Secret Key"} />
                </View>
                {!isSending &&
                    <TouchableOpacity className={loginFields.key.length < 8 || loginFields.token.length < 10 ? "disabled" : ""} activeOpacity={0.8} style={{
                        backgroundColor: "#345",
                        height: 40,
                        width: "40vh",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }} onPress={() => {
                        if (loginFields.key.length < 8 || loginFields.token.length < 10) {
                            return;
                        }

                        if (this.io) {
                            this.io.emit('on_auth', {
                                token: loginFields.token,
                                key: loginFields.key
                            })

                            this.setState({ isSending: true });
                        }
                    }}>
                        <Text style={{
                            color: "#FFF"
                        }}>LOGIN</Text>
                    </TouchableOpacity>
                }
                {isSending &&
                    <ActivityIndicator coloe="#4ac" />
                }
            </View>
        )
    }
}

const LogMessage = ({ error, message }) => {
    return (
        <View className={error.token ? "error" : ""} style={{
            height: 40,
            width: "40vh",
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderColor: "#345",
            borderWidth: 1,
            marginBottom: 15
        }}>
            <Text>{message}</Text>
        </View>
    )
}

class Blocked extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: true,
            isLogged: false,
            items: [],
            active: false,
            typeFilter: "",
            search: "",
            types: {
                T: "Team",
                C: "Club",
                Q: "Group",
                F: "User",
                L: "Tournament",
                I: "Institution",
                G: "Game"
            }
        }
    }

    componentDidMount() {
        this._isMounted = true;
        this.getData();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    getData = () => {
        const _that = this;
        FakeData.post(FakeData.apiURL+"/admin/block/system", {}, {
            headers: {
                "Content-Type": "application/json"
            },
            method: 'post',
            success(res) {
                if (_that._isMounted) {
                    const items = res.filter((item, i) => {
                        return !item.object.error
                    })
                    _that.setState({
                        items,
                        active: !_that.state.active && items[0] ? items[0] : _that.state.active,
                        isLoading: false
                    })
                    setTimeout(() => {
                        _that.getData();
                    }, 3000);
                }
            },
            error(err) {
                _that.setState({ isLoading: false });
            }
        })
    }

    unblock = (id, string, cb) => {
        const _unblock = window.confirm(`Are you sure you want to unblock ${string}?`);
        const _that = this;
        if (!_unblock) {
            return;
        }

        const _cb = () => {
            cb()
        }

        FakeData.post(FakeData.apiURL+"/admin/unblock/" + id, {}, {
            headers: {
                'Content-Type': 'application/json'
            },
            method: "POST",
            success(res) {
                if (!_that._isMounted) {
                    return;
                }
                _cb();
            },
            error(error) {
                if (!_that._isMounted) {
                    return;
                }
            }
        }, true, "", null)
    }

    render() {
        const { items, active, types, typeFilter, search } = this.state;
        return (
            <div className="dashboard-window-content">
                <LoadingState isShown={this.state.isLoading} />
                {!this.state.isLoading && this.state.items.length > 0 &&
                    <View style={{
                        flexDirection: 'row',
                        height: "100%"
                    }}>
                        <View style={{
                            flex: 1,
                            marginVertical: 10
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                border: '1px solid #ccc',
                                margin: 10
                            }}>
                                <input value={search} placeholder="Search..." style={{
                                    border: 'none',
                                    borderRight: '1px solid #ccc',
                                    flex: 1
                                }} onChange={(e) => {
                                    this.setState({ search: e.target.value });
                                }} />
                                <select value={typeFilter} style={{
                                    border: 'none',
                                    borderRight: '1px solid #ccc',
                                    flex: 1,
                                    backgroundSize: '30px 30px',
                                    margin: 0
                                }} onChange={(e) => {
                                    this.setState({ typeFilter: e.target.value });
                                }}>
                                    <option></option>
                                    {
                                        Object.keys(types).map((key, i) => {
                                            return (
                                                <option key={key} value={key}>{types[key]}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                            {
                                items.filter((item, i) => {
                                    if (typeFilter === "") {
                                        return item.object.content.toLowerCase().indexOf(search.toLowerCase()) > -1;
                                    }
                                    return item.object.content.toLowerCase().indexOf(search.toLowerCase()) > -1 && item.object.type === typeFilter;
                                }).map((item, i) => {
                                    if (item.object.error) {
                                        return null;
                                    }
                                    return (
                                        <View key={i} style={{
                                            flexDirection: 'row',
                                            padding: 10,
                                            borderBottomColor: "#ccc",
                                            borderBottomWidth: 1
                                        }} onClick={() => {
                                            this.setState({ active: item });
                                        }}>
                                            <Image source={{ uri: item.object.image }} style={{
                                                resizeMode: 'contain',
                                                height: 35,
                                                width: 35,
                                                borderRadius: 100,
                                                backgroundColor: '#555'
                                            }} />
                                            <View style={{
                                                flex: 1,
                                                justifyContent: 'center',
                                                marginHorizontal: 10
                                            }}>
                                                <Text>{item.object.content}</Text>
                                                <Text style={{
                                                    marginTop: 5,
                                                    color: "#888",
                                                    fontSize: 13
                                                }}>{types[item.object.type]}</Text>
                                            </View>
                                        </View>
                                    )
                                })
                            }
                            {items.filter((item, i) => {
                                if (typeFilter === "") {
                                    return item.object.content.toLowerCase().indexOf(search.toLowerCase()) > -1;
                                }
                                return item.object.content.toLowerCase().indexOf(search.toLowerCase()) > -1 && item.object.type === typeFilter;
                            }).length === 0 &&
                                <EmptyState isShown={true} text={"Nothing found!"} icon={"block"} />
                            }
                        </View>
                        <View style={{
                            flex: 3,
                            borderLeftColor: "#ccc",
                            borderLeftWidth: 1
                        }}>
                            {!active &&
                                <EmptyState isShown={true} text={"Please select item to preview from the left panel"} icon={"block"} />
                            }
                            {active &&
                                <View style={{
                                    flex: 1,
                                    flexDirection: 'row'
                                }}>
                                    <ScrollView style={{
                                        flex: 1,
                                        margin: 20,
                                        height: '100%'
                                    }}>
                                        <View style={[
                                            {
                                                //alignItems: 'center',
                                                justifyContent: 'center',
                                                marginBottom: 20
                                            }
                                        ]}>
                                            <Image source={{ uri: active.object.image }} style={{
                                                height: 150,
                                                width: 150,
                                                borderRadius: 100,
                                                resizeMode: 'contain'
                                            }} />
                                            <span className={"chat-msg-log"} style={{
                                                margin: '10px 0px',
                                                width: 'auto',
                                                padding: 5,
                                                borderRadius: 4,
                                                backgroundColor: "#345",
                                                alignSelf: 'flex-start',
                                                fontSize: 14,
                                                color: "#FFF"
                                            }}>{types[active.object.type]}</span>
                                            <Text style={styles.header}>{active.object.content}</Text>
                                        </View>
                                        <Text style={styles.header}>Reasons for this action</Text>
                                        <Divider name="Reasons for this action" />
                                        <View style={styles.reasonCard}>
                                            {
                                                active.reasons.map((item, i) => {
                                                    return (
                                                        <Text style={styles.reasonCardItem} key={i}>{i + 1}. {item}</Text>
                                                    )
                                                })
                                            }
                                        </View>
                                        <Text style={styles.header}>Content</Text>
                                        <Divider name="Reasons for this action" />
                                        <View style={styles.reasonCard}>
                                            {
                                                active.contents.map((item, i) => {
                                                    return (
                                                        <Text style={styles.reasonCardItem} key={i}>{item}</Text>
                                                    )
                                                })
                                            }
                                        </View>
                                        <Text style={styles.header}>Actions</Text>
                                        <Divider name="Actions" />
                                        <View style={[styles.reasonCard, {
                                            flexDirection: 'row'
                                        }]}>
                                            {
                                                [
                                                    {
                                                        name: "Unblock",
                                                        cb: () => {
                                                            this.unblock(active._id, active.object.content, () => {
                                                                this.setState({ active: false });
                                                            })
                                                        }
                                                    }
                                                ].map((item, i) => {
                                                    return (
                                                        <TouchableOpacity style={styles.reasonCardItemBtn} key={i} activeOpacity={0.8} onPress={item.cb}>
                                                            <Text style={styles.reasonCardItemBtnText}>{item.name}</Text>
                                                        </TouchableOpacity>
                                                    )
                                                })
                                            }
                                        </View>
                                    </ScrollView>
                                    <BlockedHistory key={active._id} user={active.object}/>
                                </View>
                            }
                        </View>
                    </View>
                }

                {!this.state.isLoading && this.state.items.length === 0 &&
                    <EmptyState isShown={true} text={"Nothing found!"} icon={"block"} />
                }
            </div>
        )
    }
}

class BlockedHistory extends Component{
    constructor(props){
        super(props)
        this.state = {
            isLoading: true,
            reports: []
        }
    }

    componentDidMount(){
        this._isMounted = true;
        this.getData();
    }

    getData = () => {
        const {user} = this.props;
        const data = {
            id: user.id,
            type: user.type
        }

        const cb = (reports = []) => {
            this.setState({ reports, isLoading: false });
        };

        FakeData.post(FakeData.apiURL+"/admin/report/get", data, {
            headers: {
                'Content-Type':'application/json'
            },
            success(res){
                cb(res)
            },
            error(e){
                cb([]);
            }
        })
    }

    render(){
        const {user, isProfile} = this.props;
        const {isLoading, reports} = this.state;
        return(
            <View className={"add-place"} style={{
                flex: 1,
                height: '100%',
                borderLeftColor: '#ddd',
                borderLeftWidth: 1
            }}>
                <Text style={styles.header}>Block & Report History for {user.content}</Text>
                <Divider name={`Block & Report History for ${user.content}`} />
                {isLoading &&
                    <View style={{
                        flex: 1,
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        <ActivityIndicator color="#4ac" />
                    </View>
                }
                {!isLoading && reports.length === 0 &&
                    <View style={{
                        flex: 1,
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        <Text style={{
                            color: '#555'
                        }}>No reports yet</Text>
                    </View>
                }
                {!isLoading && reports.length > 0 &&
                    <ScrollView style={{
                        flex: 1,
                        marginVertical: 10
                    }}>
                        {
                            reports.map((report,i)=>{
                                return(
                                    <BlockedHistoryItem isProfile={isProfile?true:false} key={i} report={report} />
                                )
                            })
                        }
                    </ScrollView>
                }
            </View>
        )
    }
}

class BlockedHistoryItem extends Component{
    constructor(p){
        super(p)
        this.state = {
            isShown: false
        }
    }

    render(){
        const {report} = this.props;
        const {isShown} = this.state;
        return(
            <TouchableOpacity activeOpacity={0.9} style={{
                display: 'flex',
                marginBottom: 10,
                borderColor: '#ddd',
                borderWidth: 1,
                minHeight: 100,
                padding: 10
            }} onPress={()=>{
                this.setState({ isShown: !isShown });
            }}>
                <Text>Date : {FakeData.moment(report.block_date).format('MMMM Do YYYY, h:mm:ss a')}</Text>
                <Divider name={'Stripe'}/>
                <BlockedHistoryItem.StripeProgress stripe={report.stripe}/>
                {isShown &&
                    <View>
                        <Text><strong>{report.owner_obj.content}</strong> was blocked</Text>
                    </View>
                }
                {isShown &&
                    <View>
                        <Text>Reasons</Text>
                        <Divider name={'Stripe'} />
                        <View style={styles.reasonCard}>
                            {
                                report.reasons.map((item, i) => {
                                    return (
                                        <Text style={styles.reasonCardItem} key={i}>{i + 1}. {item.title}</Text>
                                    )
                                })
                            }
                        </View>
                    </View>
                }
                {isShown &&
                    <View>
                        <Text>Content</Text>
                        <Divider name={'Stripe'} />
                        <View style={styles.reasonCard}>
                            {
                                report.contents.map((item, i) => {
                                    return (
                                        <Text style={styles.reasonCardItem} key={i}>{item}</Text>
                                    )
                                })
                            }
                        </View>
                    </View>
                }
            </TouchableOpacity>
        )
    }
}

BlockedHistoryItem.StripeProgress = ({stripe}) => {
    const stripes = [
        {
            index: 0,
            name: 'first',
            color: 'yellow'
        },
        {
            index: 0,
            name: 'second',
            color: 'orange'
        },
        {
            index: 0,
            name: 'third',
            color: 'red'
        },
        {
            index: 0,
            name: 'fourth',
            color: 'crimson'
        }
    ];

    const _stripes = [];
    for (let index = 0; index < stripes.length; index++) {
        const _stripe = stripes[index];
        _stripes.push(_stripe);
        if(stripe===_stripe.name){
            break;
        }
    }
    return(
        <View className='stripe-progress' style={{
            height: 20,
            marginVertical: 5,
            width: '100%',
            borderColor: '#ccc',
            flexDirection:'row',
            borderWidth: 1,
            borderRadius: 2,
            position: 'relative'
        }}>
            {
                _stripes.map((item, i)=>{
                    return(
                        <div tabIndex={1} className='stripe-progress-bar' key={i} style={{
                            width: 'calc(100% /4)',
                            height: '100%',
                            backgroundColor: item.color,
                        }}>
                        </div>
                    )
                })
            }
            <BlockedHistoryItem.StripeProgress.ToolTip />
        </View>
    )
}

BlockedHistoryItem.StripeProgress.ToolTip = ({data}) => {
    return(
        <div className='stripe-progress-tooltip'/>
    )
}

const styles = StyleSheet.create({
    header: {
        fontSize: 24,
        fontWeight: '600',
        lineHeight: 24
    },
    reasonCard: {
        padding: 15,
    },
    reasonCardItem: {
        fontSize: 14,
        marginVertical: 5,
    },
    reasonCardItemBtn: {
        height: 35,
        paddingHorizontal: 10,
        backgroundColor: '#4ac',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        marginRight: 10,
    },
    reasonCardItemBtnText: {
        color: "#FFF"
    }
})

const Divider = ({ name = "" }) => {
    return (
        <View style={{
            height: 2,
            width: (name.length / 1.5) * (100 / name.length),
            backgroundColor: "#4ac",
            marginVertical: 5
        }} />
    )
}

export class BannerReportView extends Component{
    constructor(p){
        super(p)
        this.state = {
            isShown: false,
            reports: []
        }
    }

    componentDidMount(){
        this._isMounted = true;
        this.getData();
    }

    getList = (stripe='frist') => {
        const stripes = [
            {
                index: 0,
                name: 'first',
                color: 'yellow'
            },
            {
                index: 0,
                name: 'second',
                color: 'orange'
            },
            {
                index: 0,
                name: 'third',
                color: 'red'
            },
            {
                index: 0,
                name: 'fourth',
                color: 'crimson'
            }
        ];
    
        const _stripes = [];
        for (let index = 0; index < stripes.length; index++) {
            const _stripe = stripes[index];
            _stripes.push(_stripe);
            if(stripe===_stripe.name){
                break;
            }
        }

        return _stripes;
    }

    getData = () => {
        const {id, type} = this.props;
        const data = {
            id,
            type
        }

        const cb = (reports = []) => {
            this.setState({ reports, isLoading: false });
        };

        FakeData.post(FakeData.apiURL+"/admin/report/get", data, {
            headers: {
                'Content-Type':'application/json'
            },
            success(res){
                cb(res)
            },
            error(e){
                cb([]);
            }
        })
    }

    render(){
        const {} = this.props;
        const {isShown, reports} = this.state;
        if(reports.length === 0){
            return null;
        }
        return (
            <div className="banner-block-report" onClick={()=>{
                this.setState({ isShown: true });
            }}>
                {
                    this.getList(reports[reports.length-1].stripe).map((item, i)=>{
                        return(
                            <div tabIndex={1} className='banner-block-report-stripe-progress-bar' key={i} style={{
                                width: 'calc(100% /4)',
                                height: '100%',
                                backgroundColor: item.color,
                            }}>
                            </div>
                        )
                    })
                }

                {isShown &&
                    <Modal isOpen={isShown} onClose={()=>{
                        this.setState({ isShown: false });
                    }}>
                        <BlockedHistory isProfile={true} style={{
                            width: '50vw',
                            minHeight: '50vh'
                        }} user={reports[0].owner_obj}/>
                    </Modal>
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/Admin.js